import Image from 'next/image';
import React, { useState, useCallback, useEffect } from 'react';
import Modal from '../../components/MyTours/BookingSearchModal';
import dynamic from 'next/dynamic';
import { Router, useRouter } from 'next/router';
import { ProfileDropdown } from './ProfileDropdown/ProfileDropdown';
const SideNav = dynamic(() => import('./SideNav'));
const Hamburger = dynamic(() => import('hamburger-react'));
const Link = dynamic(() => import('next/link'));
export const useMediaQuery = (width: number) => {
  const [targetReached, setTargetReached] = useState(false);

  const updateTarget = useCallback((e: { matches: any }) => {
    if (e.matches) {
      setTargetReached(true);
    } else {
      setTargetReached(false);
    }
  }, []);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const media = window.matchMedia(`(max-width:${width}px)`);
      media.addEventListener('change', updateTarget);

      if (media.matches) {
        setTargetReached(true);
      }

      return () => media.removeEventListener('change', updateTarget);
    }
  }, []);

  return targetReached;
};
const NavBar = () => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const [myToursModal, setMyToursModal] = useState(false);
  const router = useRouter();

  // eslint-disable-next-line no-console
  return (
    <header className="px-[6%] xl:px-[5%] 2xl:px-[5.5%] sticky top-0 z-[1100] h-[75px] lg:h-[80px] 3xl:h-[80px]  bg-gray-100 max-h-[70px] 3xl:max-h-[80px] lg:max-h-[80px] flex items-center">
      <div className="py-2 md:py-5 3xl:py-0 mx-auto w-full  ">
        <div className="flex justify-between items-center gap-3 2xl:gap-1">
          <div className="logo  flex  justify-start">
            <Link href="/">
              <Image
                alt="see sight tours logo"
                src={'/navbar-seesight-logo.png'}
                width={400}
                height={200}
                className="max-h-[80px] w-48 sm:w-[9rem] lg:w-[15rem] 3xl:w-[20rem] 3xl:max-h-[100px]"
                priority
                placeholder="blur"
                blurDataURL="/placeholder.webp"
              />
            </Link>
          </div>

          <div className=" lg:hidden xxsm:pr-[15px] sm:pr-[10px] w-[50%] flex justify-end ">
            <Hamburger toggled={isOpen} toggle={() => setOpen(!isOpen)} />
          </div>

          <div className=" hidden w-full lg:flex items-center justify-center">
            <div className="Navlinks flex text-[#060606] justify-center  text-base xl:text-lg gap-3  2xl:gap-[44px]  ">
              <Link
                href="/tours"
                className={
                  router.pathname === '/tours'
                    ? 'px-1 text-primary underline-active'
                    : 'hover:text-primary px-1'
                }
              >
                Tours
              </Link>
              <Link
                href="/private-tours"
                className={
                  router.pathname === '/private-tours'
                    ? 'px-1 text-primary underline-active'
                    : 'hover:text-primary px-1'
                }
              >
                Private Tours
              </Link>
              <Link
                href="/cities"
                className={
                  router.pathname === '/cities'
                    ? 'px-1 text-primary underline-active'
                    : 'hover:text-primary px-1'
                }
              >
                Our Cities
              </Link>
              <Link
                href="/ambassador"
                className={` sm:hidden md:flex
                      ${
                        router.pathname === '/ambassador'
                          ? 'px-1 text-primary underline-active'
                          : 'hover:text-primary px-1'
                      }`}
              >
                Ambassador
              </Link>
              <Link
                href="/guides"
                className={`hidden xl:block
                  ${
                    router.pathname === '/guides'
                      ? 'px-1 text-primary underline-active'
                      : 'hover:text-primary px-1'
                  }
                `}
              >
                Our Guides
              </Link>
              <Link
                href="/reviews"
                className={
                  router.pathname === '/reviews'
                    ? 'px-1 text-primary underline-active'
                    : 'hover:text-primary px-1'
                }
              >
                Reviews
              </Link>
              <Link
                href="/about-us"
                className={
                  router.pathname === '/about-us'
                    ? 'px-1 text-primary underline-active'
                    : 'hover:text-primary px-1'
                }
              >
                About Us
              </Link>
            </div>
          </div>
          <div className="hidden lg:flex gap-6 items-center justify-end">
            <ProfileDropdown setMyToursModal={setMyToursModal} />
          </div>
        </div>
      </div>
      <SideNav
        isOpen={isOpen}
        setOpen={setOpen}
        setOpenMyTours={setMyToursModal}
      />
      <Modal open={myToursModal} setOpenModal={setMyToursModal} />
    </header>
  );
};

export default NavBar;
